import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import ReactDOM from 'react-dom';
import { MenuItem, Button, Overlay } from 'react-bootstrap';

import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.menuPopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};

class ActionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      confirmed: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
    this.requestSync = this.requestSync.bind(this);
    this.requestCreateDemo = this.requestCreateDemo.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.requestEditInvitationExclusionList = this.requestEditInvitationExclusionList.bind(this);
    this.requestShowAppUserModal = this.requestShowAppUserModal.bind(this);
    this.requestCheckSyncPermissions = this.requestCheckSyncPermissions.bind(this);
    this.requestShowSAMLModal = this.requestShowSAMLModal.bind(this);
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  handleToggle() {
    this.setState({ open: !this.state.open, confirmed: false });
  }

  requestEdit() {
    this.setState({ open: false });
    this.props.requestEdit(this.props.data);
  }
  
  requestSync() {
    this.setState({ open: false });
    this.props.requestSync(this.props.data);
  }

  requestCreateDemo() {
    this.setState({ open: false });
    this.props.requestCreateDemo(this.props.data);
  }

  requestDelete() {
    this.setState({ open: false });
    this.props.requestDelete(this.props.data);
  }

  requestShowAppUserModal() {
    this.props.requestShowAppUserModal(this.props.data);
  }

  requestShowSAMLModal() {
    this.props.requestShowSAMLModal(this.props.data);
  }

  requestEditInvitationExclusionList() {
    this.props.requestEditInvitationExclusionList(this.props.data);
  }

  requestCheckSyncPermissions() {
    this.props.requestShowOrganizationSyncPermissions(this.props.data);
  }

  renderInner() {
    const {
      canEdit, updating, deleting,
      data: org, canDelete,
      canCheckSyncPermissions,
      dropup,
    } = this.props;

    const syncing = org && org.syncing === true;
    const disabled = updating || deleting;
    const canCreateDemo = !org.is_demo && org.organization_id !== undefined && org.organization_id !== null;
    const showAppUserModal = !org.is_demo && org.type === 'azure';
    const showSAMLModal = !org.is_demo;

    return (
      <div className="clearfix open">
        <ul className={`dropdown-menu ${dropup ? styles.dropup : ''}`}>
          <MenuItem header>{org.name}</MenuItem>
          {canEdit && <MenuItem disabled={disabled} onClick={this.requestEdit}><Fa name="edit" /> Edit</MenuItem>}
          {canEdit && !org.is_demo && org.organization_id !== null && <MenuItem disabled={disabled || syncing} onClick={this.requestSync}><Fa name={syncing ? 'spinner' : 'refresh'} spin={syncing} /> Sync Data</MenuItem>}
          {canEdit && !org.is_demo && org.organization_id !== null && <MenuItem disabled={disabled || syncing} onClick={this.requestEditInvitationExclusionList}><Fa name={syncing ? 'spinner' : 'list'} spin={syncing} /> Invitation Exclusion List</MenuItem>}
          {showAppUserModal && <MenuItem disabled={disabled || syncing} onClick={this.requestShowAppUserModal}><Fa name="user" /> Manage Application User</MenuItem>}
          {showSAMLModal && <MenuItem disabled={disabled || syncing} onClick={this.requestShowSAMLModal}><Fa name="sign-in" /> Mange SAML Settings</MenuItem>}
          {canCheckSyncPermissions && <MenuItem disabled={disabled || syncing} onClick={this.requestCheckSyncPermissions}><Fa name="database" /> Check Sync Permissions</MenuItem>}
          {canCreateDemo && <MenuItem disabled={disabled || syncing} onClick={this.requestCreateDemo}><Fa name="copy" /> Create Demo Org</MenuItem>}
          {canDelete && <MenuItem disabled={disabled || syncing} onClick={this.requestDelete}><Fa name="trash" /> Delete</MenuItem>}
        </ul>
      </div>
    );
  }

  render() {
    const { deleting, updating, data, dropup } = this.props;
    const disabled = deleting || updating;
    const { open } = this.state;
    const org = data;
    const syncing = org && org.syncing === true;
    const showSpinner = syncing || deleting;

    let label = 'Actions';
    if (deleting) {
      label = 'Deleting';
    } else if (syncing) {
      label = 'Syncing';
    }

    return (
      <div style={{ position: 'relative' }}>
        <Button
          disabled={disabled}
          ref={(target) => {
            this.target = target;
          }}
          bsStyle="primary"
          bsSize="xs"
          onClick={this.handleToggle}
        >
          {label} <Fa name={showSpinner ? 'spinner' : 'caret-down'} spin={showSpinner} />
        </Button>
        <Overlay
          show={open}
          rootClose
          onHide={() => this.setState({ open: false })}
          placement={dropup ? 'top' : 'bottom'}
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }
}

ActionRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
    tru_voice_clients: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  deleting: PropTypes.bool,
  updating: PropTypes.bool,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  requestEdit: PropTypes.func,
  requestSync: PropTypes.func,
  requestCreateDemo: PropTypes.func,
  requestDelete: PropTypes.func,
  requestEditInvitationExclusionList: PropTypes.func,
  requestShowAppUserModal: PropTypes.func,
  requestShowSAMLModal: PropTypes.func,
  canCheckSyncPermissions: PropTypes.bool,
  dropup: PropTypes.bool,
  requestShowOrganizationSyncPermissions: PropTypes.func,
};
ActionRenderer.defaultProps = {
  value: null,
  data: null,
  deleting: false,
  updating: false,
  canEdit: false,
  canDelete: false,
  dropup: false,
  requestEdit: () => {},
  requestSync: () => {},
  requestCreateDemo: () => {},
  requestDelete: () => {},
  requestEditInvitationExclusionList: () => {},
  requestShowAppUserModal: () => {},
  requestShowSAMLModal: () => {},
  canCheckSyncPermissions: false,
  requestShowOrganizationSyncPermissions: () => {},
};

export default ActionRenderer;
